import React from 'react';

import { Application } from '../Application';
import { Authenticated } from '../Authenticated';
import { EmailVerified } from '../EmailVerified';
import { Funnel } from '../Funnel';
import { PaymentTracker } from '../PaymentTracker';

export const FunnelWrappers: React.FC<{ status: string }> = ({ children, status }) => (
  <Authenticated>
    <PaymentTracker>
      <EmailVerified>
        <Application>
          <Funnel status={status}>
            { children }
          </Funnel>
        </Application>
      </EmailVerified>
    </PaymentTracker>
  </Authenticated>
);
